import { GetSectorSchemaParams, GetVenueSchemaParams, ThunkService } from '.';
import { GetCategoryParams, GetEventByCategoriesParams, GetEventByTypeParams } from './repositories';
import { AppSettings } from '../settings/appSettings';

export default function useApi() {
  const thunkService = new ThunkService({ baseURL: `${AppSettings.BASE_API_URL}` });
  const eventsApi = getEventsAPI(thunkService);
  const sessionApi = getSessionAPI(thunkService);
  return {
    eventsApi,
    sessionApi,
  };
}

export function getEventsAPI(thunkService: ThunkService) {
  return {
    getEventsCategories: () => thunkService.api.events.getEventsCategories(),
    getCategory: (params: GetCategoryParams) => thunkService.api.events.getCategory(params),
    getEventsByType: (params: GetEventByTypeParams) => thunkService.api.events.getEventsByType(params),
    getEventsByCategories: (params: GetEventByCategoriesParams) =>
      thunkService.api.events.getEventsByCategories(params),
    searchEvents: async (search: string) => thunkService.api.events.searchEvents(search),
    searchLocations: async (search: string) => thunkService.api.events.searchLocations(search),
    getLocations: async () => thunkService.api.events.getLocations(),
    getDatepickerDates: (date: Date) => thunkService.api.events.getDatepickerDates(date),
    getSectorSchema: (date: GetSectorSchemaParams) => thunkService.api.events.getSectorSchema(date),
    getVenueSchema: (date: GetVenueSchemaParams) => thunkService.api.events.getVenueSchema(date),
  };
}

export function getSessionAPI(thunkService: ThunkService) {
  return {
    checkStatus: (sessionId: string, email: string) =>
      thunkService.api.base.get(`/waitingroom/${sessionId}?email=${email}`),
    heartBeat: (sessionId: string, email: string) => thunkService.api.base.post(`/heartbeat/${sessionId}`, { email }),
    sessionConfirm: (sessionId: string, email: string) =>
      thunkService.api.base.post(`/waitingroom/${sessionId}/confirm`, { email }),
    sessionsLeave: (sessionId: string, email: string) =>
      thunkService.api.base.post(`/waitingroom/${sessionId}/leave`, { email }),
  };
}

export type CheckStatusType = {
  added: boolean;
  blocked: boolean;
  isReady: boolean;
  position: number;
  userExist: boolean;
};
